module.exports = __webpack_public_path__ + "assets/HKNova-Regular.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Regular.svg
// module id = 111
// module chunks = 0